import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { sessionService } from '@/providers/services/auth/session';
import { USER_TYPE, PARTNERS_TYPE_ARRAY, PERMISSION_CHECK } from '@/utils/constants';

@Component({
    name: 'partner-catalog',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class PartnerCatalog extends Vue {

    private get session() {
        return sessionService.getSession();
    }

    private registryMenu: Array<{ route: string, icon: string, name: string, subMenu?: any, queryParams?: any }> = [
        {
            route: '/partner-catalog/partners-list',
            queryParams: { activeMenu: 'content-partner' },
            icon: 'groups',
            name: 'Partner Registry',
            subMenu: [
                {
                    name: 'Content Partners',
                    groupsType: ['content_developers'],
                    key: 'content-partner',
                    // route: '/partner-catalog/partners-list',
                    queryParams: { activeMenu: 'content-partner' },
                },
                {
                    name: 'eLearning Providers',
                    groupsType: ['lab_schools', 'schools'],
                    key: 'learner-product',
                    // route: '/partner-catalog/partners-list',
                    queryParams: { activeMenu: 'learner-product' },
                },
                {
                    name: 'EdTech Companies',
                    groupsType: ['integration_partners'],
                    key: 'tech-partner',
                    // route: '/partner-catalog/partners-list',
                    queryParams: { activeMenu: 'tech-partner' },
                },
                {
                    name: 'Researchers',
                    groupsType: ['researchers'],
                    key: 'researcher',
                    // route: '/partner-catalog/partners-list',
                    queryParams: { activeMenu: 'researcher' },
                },
                // {
                //     name: 'Funders',
                //     groupsType: ['funders'],
                //     key: 'program-partner',
                //     // route: '/partner-catalog/partners-list',
                //     queryParams: { activeMenu: 'program-partner' },
                // },
            ],
        },
        {
            route: '/partner-catalog/content-registry',
            icon: 'local_library',
            name: 'Content Registry',
        },
        {
            route: '/partner-catalog/tool-registry',
            icon: 'construction',
            name: 'Tool Developers',
        },
    ];

    private permissonCheck = PERMISSION_CHECK;

    private toolPartnerTypes: string[] = PARTNERS_TYPE_ARRAY;

    private userType: string = '';

    private userTypeList: any = USER_TYPE;

    private toolPartners: any = [];

    private activeMenu: any = '';

    public created() {
        this.userType = this.$access.getUserType();
        this.fetchPartnerList();
        if (this.userType !== 'SUPER_USER') {
            this.registryMenu.splice(0, 1);
        }
        if (!this.$access.isHavingPermisson(this.permissonCheck.viewPartner)) {
            this.removeNotPermitted('Partner Registry');
        }
        if (!this.$access.isHavingPermisson(this.permissonCheck.viewProduct)) {
            this.removeNotPermitted('Content Registry');
        }
        if (!this.$access.isHavingPermisson(this.permissonCheck.viewTool)) {
            this.removeNotPermitted('Tool Registry');
        }
        this.routeFirst();
    }

    // ---------------------------------------------------------------------------
    // Methods

    private fetchPartnerList() {
        this.$store.dispatch('partnerDataStore/fetchModifiedPartnerList').then((partners: any) => {
            this.toolPartnerTypes.forEach((partnerType) => {
                if (partners.hasOwnProperty(partnerType)) {
                    this.toolPartners = [...partners[partnerType], ...this.toolPartners];
                }
            });
        });
    }

    private removeNotPermitted(checkItem: any) {
        const regIndex = this.registryMenu.findIndex((item: any) => item.label === checkItem);
        if (regIndex !== -1) {
            this.registryMenu.splice(regIndex, 1);
        }
    }

    private onChangeRoute(currentPath: string) {
        // this.currentRoutePath = currentPath;
        this.$router.push(currentPath);
    }

    private onSubMenu(menutItem: any) {
        this.$router.push(`/partner-catalog/partners-list/?activeMenu=${menutItem.key}`);
    }

    private routeFirst() {
        const newRoute = this.registryMenu[0].route;
        if (newRoute === '/partner-catalog/partners-list') {
            const path = this.registryMenu[0].queryParams.activeMenu;
            this.$router.push(`/partner-catalog/partners-list/?activeMenu=${path}`)
                .then(() => { const nav = 'navigated'; })
                .catch(() => { const error = 'error'; });
        } else {
            this.$router.push(newRoute)
                .then(() => { const nav = 'navigated'; })
                .catch(() => { const error = 'error'; });
        }
    }

}
